<button class="__button" [attr.type]="typeButton" [disabled]="disabled" (click)="onClick($event)">
  <ng-content></ng-content>
</button>
